import { render, staticRenderFns } from "./YpoAwards.vue?vue&type=template&id=7dc03203&scoped=true&"
import script from "./YpoAwards.vue?vue&type=script&lang=js&"
export * from "./YpoAwards.vue?vue&type=script&lang=js&"
import style0 from "./YpoAwards.vue?vue&type=style&index=0&id=7dc03203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc03203",
  null
  
)

export default component.exports